import { render } from "./DayReview.vue?vue&type=template&id=43a87d7e&scoped=true"
import script from "./DayReview.vue?vue&type=script&lang=js"
export * from "./DayReview.vue?vue&type=script&lang=js"

import "./DayReview.vue?vue&type=style&index=0&id=43a87d7e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43a87d7e"]])

export default __exports__